
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 140 140"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"currentColor"}},[_c('path',{attrs:{"d":"M89.133 82.693a46.492 46.492 0 01-29.347-64.376 2.917 2.917 0 00-.105-2.666 135.118 135.118 0 00-8.237-13.359 6.376 6.376 0 00-9.555 0C33.28 13.58 0 77.583 0 96.25 0 119.146 22.243 140 46.667 140s46.666-20.854 46.666-43.75a45.074 45.074 0 00-2.21-11.573 2.917 2.917 0 00-1.99-1.984zm-44.035 40.128a4.38 4.38 0 01-5.25 3.296 30.526 30.526 0 01-20.598-16.252 4.375 4.375 0 117.834-3.897 21.793 21.793 0 0014.747 11.614 4.375 4.375 0 013.266 5.239z"}}),_c('path',{attrs:{"d":"M102.083 0A37.917 37.917 0 10140 37.917 37.963 37.963 0 00102.083 0zm17.5 43.75h-8.75a2.917 2.917 0 00-2.916 2.917v8.75a5.833 5.833 0 01-11.667 0v-8.75a2.917 2.917 0 00-2.917-2.917h-8.75a5.833 5.833 0 010-11.667h8.75a2.917 2.917 0 002.917-2.916v-8.75a5.833 5.833 0 0111.667 0v8.75a2.917 2.917 0 002.916 2.916h8.75a5.833 5.833 0 010 11.667z"}})])])
          )
        }
      }
    